import React from 'react';
import { motion } from 'framer-motion';

export const ProblemStatements = () => {
  const problems = [
    {
      title: "You're Burned Out from Doing Everything 'Right'",
      description: "You've followed the rules, ticked the boxes, built the life you thought you were supposed to want. But somewhere along the way, you lost yourself. You're exhausted, running on empty, and wondering if this is really all there is."
    },
    {
      title: "You Doubt Yourself More Than You Trust Yourself",
      description: "Every decision feels heavy. You second-guess your choices, overthink every move, and feel like you're constantly waiting for permission to just... be yourself. The voice in your head is louder than the truth in your heart."
    },
    {
      title: "You Feel Stuck, Misaligned, and Ready for Something Different",
      description: "You know something needs to change, but you're not sure what or how. You feel disconnected from your purpose, your relationships, your own potential. You're craving alignment, clarity, and the courage to finally step into who you're meant to be."
    }
  ];

  return (
    <section className="py-32 md:py-40 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mb-24 text-center"
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-normal text-[#1a1a1a] mb-6 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
            If any of this sounds familiar...
          </h2>
          <p className="text-xl text-[#6a6a6a] font-light">You're in the right place.</p>
        </motion.div>

        <div className="space-y-16">
          {problems.map((problem, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: index * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="border-l-2 border-[#704229] pl-8 md:pl-12"
            >
              <h3 className="text-3xl md:text-4xl font-normal text-[#2a2a2a] mb-6 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                {problem.title}
              </h3>
              <p className="text-lg md:text-xl text-[#5a5a5a] leading-loose font-light">
                {problem.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
